import React, {Suspense} from 'react';
import {Provider} from 'react-redux';
import {Routes, Route} from 'react-router-dom';
import {AnimatePresence} from 'framer-motion';
import {ThemeProvider} from '@tenancy.nz/design-system';
import GlobalStyle from './components/GlobalStyle';
import Home from './components/Home';
import Loader from './components/Loader';
import NotFound from './components/NotFound';
import AuthFeature from './features/auth/AuthFeature';
import BookingDetailFeature from './features/booking/BookingDetailFeature';
import ListingFeature from './features/listing/ListingFeature';
import ListingDetailFeature from './features/listing/ListingDetailFeature';
import ToastFeature from './features/toast/ToastFeature';
import {initGA} from './analytics';
import store from './store';
import theme from './theme';

initGA();

function App() {
  return (
    <Provider store={store}>
      <ThemeProvider theme={theme}>
        <GlobalStyle />
        <AnimatePresence>
          <Suspense fallback={<Loader />}>
            <AuthFeature>
              {() => (
                <Routes>
                  <Route index element={<Home />} />
                  <Route path="/:slug" element={<ListingFeature />} />
                  <Route
                    path="/listing/:id"
                    exact
                    element={<ListingDetailFeature />}
                  />
                  <Route
                    path="/listing/:id/booking/:bookingId"
                    exact
                    element={<BookingDetailFeature />}
                  />
                  <Route path="/listing/:id/*" element={<NotFound />} />
                  <Route path="/404" element={<NotFound />} />
                  <Route path="/*" element={<NotFound />} />
                </Routes>
              )}
            </AuthFeature>
          </Suspense>
        </AnimatePresence>
        <ToastFeature />
      </ThemeProvider>
    </Provider>
  );
}

export default App;
